module.exports = __webpack_public_path__ + "static/media/thumbnail_ally-ups-cart.2d8c8cf9.jpg";